import ShadowRoot from '@/components/elements/ShadowRoot.vue';

export default {
    install(app) {
        app.component('ShadowRoot', ShadowRoot);
    },
};
